<template>
    <b-row>
        <b-row class="w100 text-center" style="margin-top:10px;margin-bottom:0">
            <b-col cols="7" >
                <!-- intervals -->
                <p><i class="el-input__icon el-range__icon el-icon-time"></i> {{ $t("messages.interval") }}</p>
            </b-col>
            <b-col cols="3" v-if="this.info.pumpType > 0">
                <!-- velocity -->
                <p>{{ $t("messages.velocity") }}</p>
            </b-col>
        </b-row>
        <b-row class="w100 p0">
            <b-col cols="1" class="fspecial mb-0 text-right">
                <p style="line-height:35px;margin-bottom:0;">1</p>
            </b-col>
            <b-col cols="3" class="text-left">
                  <el-time-picker v-model="timer1" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
            <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                <p style="line-height:35px;margin-bottom:0;">-</p>
            </div>
            <b-col cols="3" class="text-left">
                <el-time-picker  v-model="timer1To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
            <b-col cols="3" class="text-left" v-if="this.info.pumpType > 0">
                <el-select v-model="info.timerVel1" :placeholder=' $t("messages.select")'>
                    <el-option v-for="item in velocities" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </b-col>
        </b-row>
            <b-row class="w100 p0">
            <b-col cols="1" class="fspecial mb-0 text-right">
                <p style="line-height:35px;margin-bottom:0;">2</p>
            </b-col>
            <b-col cols="3" class="text-left">
                <el-time-picker v-model="timer2" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
            <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                <p style="line-height:35px;margin-bottom:0;">-</p>
            </div>
            <b-col cols="3" class="text-left">
                <el-time-picker v-model="timer2To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
            <b-col cols="3" class="text-left" v-if="this.info.pumpType > 0">
                <el-select v-model="info.timerVel2" :placeholder=' $t("messages.select")'>
                    <el-option v-for="item in velocities" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </b-col>
        </b-row>
        <b-row class="w100 p0">
            <b-col cols="1" class="fspecial mb-0 text-right">
                <p style="line-height:35px;margin-bottom:0;">3</p>
            </b-col>
            <b-col cols="3" class="text-left">
               <el-time-picker v-model="timer3" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
            <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                <p style="line-height:35px;margin-bottom:0;">-</p>
            </div>
            <b-col cols="3" class="text-left">
               <el-time-picker v-model="timer3To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
            </b-col>
    
            <b-col  cols="3" class="text-left" v-if="this.info.pumpType > 0">
                <el-select v-model="info.timerVel3" :placeholder=' $t("messages.select")'>
                    <el-option v-for="item in velocities" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </b-col>
        </b-row>
    </b-row>

</template>

<script>
export default {
    name: 'Timers',
    props: {
        info: {}
    },
    data() {
        return {
            velocities: [
                // slow / medium / high
                {
                    value: 0,
                    label: this.$t("messages.slow")
                },
                {
                    value: 1,
                    label: this.$t("messages.medium")
                },
                {
                    value: 2,
                    label: this.$t("messages.high")
                }
            ]
        }
    },
    computed:{
        timer1:{
            get(){
                return this.$moment.unix(this.info.interval1.from).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval1.from = this.$moment.duration(newDate).asSeconds()
            }
        },
        timer1To:{
            get(){
               return this.$moment.unix(this.info.interval1.to).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval1.to = this.$moment.duration(newDate).asSeconds()
            }
        },
        timer2:{
            get(){
                return this.$moment.unix(this.info.interval2.from).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval2.from = this.$moment.duration(newDate).asSeconds()
            }
        },

        timer2To:{
            get(){
                return this.$moment.unix(this.info.interval2.to).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval2.to= this.$moment.duration(newDate).asSeconds()
            }
        },
        timer3:{
            get(){
                return this.$moment.unix(this.info.interval3.from).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval3.from = this.$moment.duration(newDate).asSeconds()
            }
        },
        timer3To:{
            get(){
                return this.$moment.unix(this.info.interval3.to).utc().format("HH:mm")
            },
            set(newDate) { 
                this.info.interval3.to= this.$moment.duration(newDate).asSeconds()
            }
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/utils/Timers.vue